import React, { useEffect, useState } from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaPinterestP,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";
import "../assets/css/Footer.css";
import footerlogo from "../assets/images/footerlogo.png";
import { Row, Col, Container } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/axios";

const SHOP_STATE_KEY = "shop_state_v1";

const SHOP_DEFAULT_STATE = {
  category: {
    category_name: "",
    category_id: 0,
  },
  subcategory: null,
  searchTerm: "",
  sortBy: "name_asc",
  first: 0,
  rows: 21,
  occasionId: null,
};

const Footer = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  const saveShopState = (nextState) => {
    localStorage.setItem(SHOP_STATE_KEY, JSON.stringify(nextState));

    window.dispatchEvent(
      new CustomEvent("shop-state-updated", {
        detail: nextState,
      })
    );
  };

  const resetAndNavigateShop = () => {
    saveShopState(SHOP_DEFAULT_STATE);

    navigate("/shop", {
      state: {
        reset: true,
        category: "",
        subcategory: null,
        searchTerm: "",
        occasionId: null,
        sortBy: "name_asc",
      },
    });
  };

  const saveAndNavigateShop = ({
    category = "",
    subcategory = null,
    searchTerm = "",
    replace = false,
  }) => {
    const selectedCategory =
      categories.find((c) => c.category_name === category) || {
        category_name: category,
      };

    const nextState = {
      ...SHOP_DEFAULT_STATE,
      category: category
        ? selectedCategory
        : {
            category_name: "",
            category_id: 0,
          },
      subcategory,
      searchTerm,
    };

    saveShopState(nextState);

    navigate("/shop", {
      replace,
      state: {
        reset: false,
        category,
        subcategory,
        searchTerm,
        occasionId: null,
        sortBy: "name_asc",
      },
    });
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get(
          "/CategoryRoutes/customer/categories-with-subcategories"
        );

        if (res.data?.success) {
          setCategories(res.data.data || []);
        }
      } catch (error) {
        console.error("Footer categories fetch failed:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <footer className="footer">
      <Container className="containerfull">
        <Row className="footer-top justify-content-between mx-0 pb-3 pb-lg-5">
          <Col
            lg={3}
            md={12}
            sm={12}
            xs={12}
            className="pe-10 d-flex flex-column justify-content-end"
          >
            <img
              src={footerlogo}
              alt="Footer logo"
              className="img-fluid resp_flogo"
            />

            <div className="social-icons mt-3 mt-lg-5">
              <a href="https://www.instagram.com/shaadimaterial" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61591189757592" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://youtube.com/@weddingsbygraphe?si=tw8y_pPN58hMV6Vn" target="_blank" rel="noopener noreferrer">
                <FaYoutube />
              </a>
              <a href="https://www.linkedin.com/company/shaadimaterial" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
            </div>
          </Col>

          <Col lg={4} md={12} sm={12} xs={12} className="footer-col">
            <h4>Discover</h4>

            <div className="d-flex flex-wrap gap-lg-3 gap-0 justify-content-between">
              <div className="footer-nav footerul">
                <ul>
                  <li>
                    <span
                      className="footer-link-btn"
                      onClick={resetAndNavigateShop}
                    >
                      Shop
                    </span>
                  </li>

                  {categories.length > 0 &&
                    categories.slice(0, 12).map((cat) => (
                      <li key={cat.category_id || cat.category_name}>
                        <span
                          className="footer-link-btn"
                          onClick={() =>
                            saveAndNavigateShop({
                              category: cat.category_name,
                              subcategory: null,
                              searchTerm: "",
                            })
                          }
                        >
                          {cat.category_name}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </Col>

          <Col
            lg={3}
            md={12}
            sm={12}
            xs={12}
            className="footer-col d-flex flex-column justify-content-between"
          >
            <div>
              <h4>Consumer Policy</h4>

              <div className="footer-nav d-flex">
                <ul>
                  <li>
                    <Link to="/terms-and-condition">Terms of Service</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/cookie-policy">Cookie Policy</Link>
                  </li>
                  <li>
                    <Link to="/coin-policy">Coin Policy</Link>
                  </li>
                  <li>
                    <Link to="/refund-policy">Refund policy</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="footer-email">
              <p>
                Write to us at <span>contact@shaadimaterial.com</span>
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <div className="footer-bottom">
        <Container className="containerfull">
          <Row className="justify-content-between align-items-center">
            <Col lg={12} md={12} sm={12} xs={12} className="text-center">
              © {new Date().getFullYear()} Graphē. All rights reserved.
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;